// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NonFictional.module.css */
.NonFictional_container__hZOQ1 {
  display: flex;
  justify-content: center;
  padding: 0px;
  background-color: #1A1A1A;
  color: #fff;
  max-width: 95%;
  margin: 0 auto;
  width: 100%;
}

.NonFictional_boxedWrapper__sCJUH {
  max-width: 100%;
  width: 100%;
  background: #1A1A1A;
}

/* Header: Heading on left and View All button on right */
.NonFictional_header__O\\+yl8 {
  display: flex;
  justify-content: space-between; /* Heading left, button right */
  align-items: center;
  margin-bottom: 0px;
  flex-wrap: nowrap; /* Prevent wrapping */
}

.NonFictional_header__O\\+yl8 h2 {
  font-size: 20px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.NonFictional_viewAllButton__Zmnte {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 8px;
}

.NonFictional_viewAllButton__Zmnte:hover {
  background-color: #555;
}

/* Swiper / Book List Styling */
.NonFictional_bookList__7g8RO {
  margin-bottom: 0px;
  width: 100%;
}

.NonFictional_swiper__jB3F\\+ {
  width: 100%;
}

.NonFictional_bookItem__DWmnI {
  display: block;
  border-radius: 5px;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  height: 100%;
  aspect-ratio: auto; /* Maintain consistent aspect ratio */
}



.NonFictional_bookImage__JJ6pz {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

/* Loading & Error Text */
.NonFictional_loading__VVPUv, .NonFictional_error__ciRYA {
  text-align: center;
  font-size: 18px;
}

.NonFictional_error__ciRYA {
  color: red;
}

/* Navigation Buttons Styling - No global styling used */
.NonFictional_navButton__IGVp3 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.15);
  border: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.NonFictional_navButton__IGVp3:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-50%) scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.NonFictional_prevButton__qKKpD {
  left: 10px;
}

.NonFictional_nextButton__kze8r {
  right: 10px;
}

.NonFictional_navIcon__Ta8dJ {
  color: white;
  width: 24px;
  height: 24px;
}

/* Add classes for custom swiper navigation to avoid global styles */
.NonFictional_customSwiperNav__M2xPA .swiper-button-next,
.NonFictional_customSwiperNav__M2xPA .swiper-button-prev {
  width: 40px;
  height: 40px;
}

/* RESPONSIVENESS */

/* Tablets & Small Screens */
@media (max-width: 1024px) {
  .NonFictional_boxedWrapper__sCJUH {
    max-width: 90%;
    padding: 15px;
  }
  .NonFictional_header__O\\+yl8 h2 {
    font-size: 20px;
  }
  .NonFictional_viewAllButton__Zmnte {
    font-size: 14px;
    padding: 8px 16px;
  }
  .NonFictional_bookItem__DWmnI {
    aspect-ratio: auto;
  }
  .NonFictional_bookImage__JJ6pz {
    height: 100%;
  }
}

/* Mobile Screens */
@media (max-width: 768px) {
  
  .NonFictional_boxedWrapper__sCJUH {
    max-width: 100%;
  }
  /* Keep header in row for mobile with proper spacing */
  .NonFictional_header__O\\+yl8 {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .NonFictional_header__O\\+yl8 h2 {
    font-size: 16px;
  }
  .NonFictional_viewAllButton__Zmnte {
    font-size: 13px;
    padding: 6px 12px;
  }
  .NonFictional_bookItem__DWmnI {
    aspect-ratio: auto; /* Slightly adjusted aspect ratio for mobile */
  }
  .NonFictional_bookImage__JJ6pz {
    height: 100%;
  }
}

/* Small Mobile Screens */
@media (max-width: 480px) {

  .NonFictional_boxedWrapper__sCJUH {
    max-width: 100%;
    padding: 0px;
  }
  .NonFictional_header__O\\+yl8 h2 {
    font-size: 18px;
  }
  .NonFictional_viewAllButton__Zmnte {
    font-size: 12px;
    padding: 5px 10px;
  }
  .NonFictional_navButton__IGVp3 {
    width: 36px;
    height: 36px;
  }
  /* Fixed height issue on very small screens */
  .NonFictional_bookItem__DWmnI {
    aspect-ratio: auto;
    height: auto;
  }
  .NonFictional_bookImage__JJ6pz {
    height: 180px;
   /* Limit maximum height on very small screens */
  }
}

/* Extra Small Mobile Screens */
@media (max-width: 375px) {
  .NonFictional_bookImage__JJ6pz {
    max-height: 150px; /* Further limit height on extra small screens */
  }
}

/* No content message */
.NonFictional_noContent__ag8Ii {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #aaa;
}

/* No categories message */
.NonFictional_noCategories__rvwAw {
  text-align: center;
  padding: 30px;
  font-size: 18px;
  color: #aaa;
}`, "",{"version":3,"sources":["webpack://./src/ShortStories/Component/CSS/NonFictional.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8BAA8B,EAAE,+BAA+B;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,kBAAkB,EAAE,qCAAqC;AAC3D;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA,oEAAoE;AACpE;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;;AAEnB,4BAA4B;AAC5B;EACE;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;;EAEE;IACE,eAAe;EACjB;EACA,sDAAsD;EACtD;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB,EAAE,8CAA8C;EACpE;EACA;IACE,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;;EAEE;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA,6CAA6C;EAC7C;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,aAAa;GACd,+CAA+C;EAChD;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB,EAAE,gDAAgD;EACrE;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb","sourcesContent":["/* NonFictional.module.css */\n.container {\n  display: flex;\n  justify-content: center;\n  padding: 0px;\n  background-color: #1A1A1A;\n  color: #fff;\n  max-width: 95%;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.boxedWrapper {\n  max-width: 100%;\n  width: 100%;\n  background: #1A1A1A;\n}\n\n/* Header: Heading on left and View All button on right */\n.header {\n  display: flex;\n  justify-content: space-between; /* Heading left, button right */\n  align-items: center;\n  margin-bottom: 0px;\n  flex-wrap: nowrap; /* Prevent wrapping */\n}\n\n.header h2 {\n  font-size: 20px;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.viewAllButton {\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px;\n}\n\n.viewAllButton:hover {\n  background-color: #555;\n}\n\n/* Swiper / Book List Styling */\n.bookList {\n  margin-bottom: 0px;\n  width: 100%;\n}\n\n.swiper {\n  width: 100%;\n}\n\n.bookItem {\n  display: block;\n  border-radius: 5px;\n  overflow: hidden;\n  transition: transform 0.3s ease-in-out;\n  cursor: pointer;\n  height: 100%;\n  aspect-ratio: auto; /* Maintain consistent aspect ratio */\n}\n\n\n\n.bookImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n/* Loading & Error Text */\n.loading, .error {\n  text-align: center;\n  font-size: 18px;\n}\n\n.error {\n  color: red;\n}\n\n/* Navigation Buttons Styling - No global styling used */\n.navButton {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.navButton:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-50%) scale(1.05);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\n}\n\n.prevButton {\n  left: 10px;\n}\n\n.nextButton {\n  right: 10px;\n}\n\n.navIcon {\n  color: white;\n  width: 24px;\n  height: 24px;\n}\n\n/* Add classes for custom swiper navigation to avoid global styles */\n.customSwiperNav :global(.swiper-button-next),\n.customSwiperNav :global(.swiper-button-prev) {\n  width: 40px;\n  height: 40px;\n}\n\n/* RESPONSIVENESS */\n\n/* Tablets & Small Screens */\n@media (max-width: 1024px) {\n  .boxedWrapper {\n    max-width: 90%;\n    padding: 15px;\n  }\n  .header h2 {\n    font-size: 20px;\n  }\n  .viewAllButton {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n  .bookItem {\n    aspect-ratio: auto;\n  }\n  .bookImage {\n    height: 100%;\n  }\n}\n\n/* Mobile Screens */\n@media (max-width: 768px) {\n  \n  .boxedWrapper {\n    max-width: 100%;\n  }\n  /* Keep header in row for mobile with proper spacing */\n  .header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  .header h2 {\n    font-size: 16px;\n  }\n  .viewAllButton {\n    font-size: 13px;\n    padding: 6px 12px;\n  }\n  .bookItem {\n    aspect-ratio: auto; /* Slightly adjusted aspect ratio for mobile */\n  }\n  .bookImage {\n    height: 100%;\n  }\n}\n\n/* Small Mobile Screens */\n@media (max-width: 480px) {\n\n  .boxedWrapper {\n    max-width: 100%;\n    padding: 0px;\n  }\n  .header h2 {\n    font-size: 18px;\n  }\n  .viewAllButton {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n  .navButton {\n    width: 36px;\n    height: 36px;\n  }\n  /* Fixed height issue on very small screens */\n  .bookItem {\n    aspect-ratio: auto;\n    height: auto;\n  }\n  .bookImage {\n    height: 180px;\n   /* Limit maximum height on very small screens */\n  }\n}\n\n/* Extra Small Mobile Screens */\n@media (max-width: 375px) {\n  .bookImage {\n    max-height: 150px; /* Further limit height on extra small screens */\n  }\n}\n\n/* No content message */\n.noContent {\n  text-align: center;\n  padding: 20px;\n  font-size: 16px;\n  color: #aaa;\n}\n\n/* No categories message */\n.noCategories {\n  text-align: center;\n  padding: 30px;\n  font-size: 18px;\n  color: #aaa;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NonFictional_container__hZOQ1`,
	"boxedWrapper": `NonFictional_boxedWrapper__sCJUH`,
	"header": `NonFictional_header__O+yl8`,
	"viewAllButton": `NonFictional_viewAllButton__Zmnte`,
	"bookList": `NonFictional_bookList__7g8RO`,
	"swiper": `NonFictional_swiper__jB3F+`,
	"bookItem": `NonFictional_bookItem__DWmnI`,
	"bookImage": `NonFictional_bookImage__JJ6pz`,
	"loading": `NonFictional_loading__VVPUv`,
	"error": `NonFictional_error__ciRYA`,
	"navButton": `NonFictional_navButton__IGVp3`,
	"prevButton": `NonFictional_prevButton__qKKpD`,
	"nextButton": `NonFictional_nextButton__kze8r`,
	"navIcon": `NonFictional_navIcon__Ta8dJ`,
	"customSwiperNav": `NonFictional_customSwiperNav__M2xPA`,
	"noContent": `NonFictional_noContent__ag8Ii`,
	"noCategories": `NonFictional_noCategories__rvwAw`
};
export default ___CSS_LOADER_EXPORT___;
